import {
  ActiveInactiveStatus,
  ApiListRequest,
  ApiListResponse,
  SessionPackDTO,
} from "@gymflow/types";
import {
  infiniteQueryOptions,
  QueryKey,
  queryOptions,
} from "@tanstack/react-query";

import { api } from "../../api";
import { numberPagination } from "../../numberPagination";

const keys = {
  all: () => ["hostedApiCreditPack"] as QueryKey,
  id: (id?: unknown) => [...keys.all(), "id", id] as QueryKey,
  list: (filter: unknown) => [...keys.all(), "list", filter] as QueryKey,
};

export const hostedApiCreditPack = {
  keys,
  queries: {
    id: (id: number | undefined) =>
      queryOptions({
        queryKey: keys.id(id),
        queryFn: async () => {
          return (await api.get<SessionPackDTO>(`/hosted/sessionpack/${id}`))
            .data;
        },
        enabled: !!id,
      }),
  },
  infiniteQueries: {
    list: (
      params: {
        status?: ActiveInactiveStatus;
        id?: number[];
        hasActivityCategory?: boolean;
        hasAppointableCategory?: boolean;
        appointableCategories?: number[];
        classCategories?: number[];
      } & ApiListRequest,
    ) =>
      infiniteQueryOptions({
        queryKey: keys.list(params),
        queryFn: async ({ pageParam }) => {
          return (
            await api.get<ApiListResponse<SessionPackDTO>>(
              `/hosted/sessionpack`,
              {
                params: { ...params, page: pageParam },
              },
            )
          ).data;
        },
        ...numberPagination,
      }),
  },
  mutations: {},
};
